var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"userBriefHistory pa-2 pa-lg-5",class:_vm.$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2',attrs:{"tile":"","flat":""}},[_c('LiveTradeTabs')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }